import { factory } from 'Utils/content/flab';
import Config from '../config';

export default factory(
  Config.ACTIVE_UID_EXPERIMENTS,
  Config.ACTIVE_UNIQUE_ID_EXPERIMENTS,
);
